import React from 'react';
import './Terms.css';

const Privacy: React.FC = () => (
  <div className="terms-page">
    <div className="terms-content">
      <h1>Privacy Policy (Website)</h1>
      <p><strong>Effective Date:</strong> May 18, 2026</p>
      <p>
        This policy applies to information collected through our website (<strong>healmusicapp.com</strong>), including
        when you join our waitlist. For our full Privacy Policy covering the HEAL mobile app and all Services, see our{' '}
        <a href="/app-privacy">HEAL Privacy Policy</a>.
      </p>
      <p>
        Heal Music Ltd. (&quot;Heal&quot;, &quot;we&quot;, &quot;our&quot;, or &quot;us&quot;) respects your privacy. This Privacy Policy explains how we
        collect, use, and protect information when you visit our website (<strong>healmusicapp.com</strong>) and join our
        waitlist.
      </p>

      <h2>1. Information We Collect</h2>
      <ul>
        <li>Name and email address (via waitlist form)</li>
        <li>IP address, browser type, device type</li>
        <li>Cookies and usage data through analytics tools (e.g., Google Analytics, Meta Pixel)</li>
      </ul>

      <h2>2. How We Use Your Information</h2>
      <ul>
        <li>To manage the waitlist and communicate with you about HEAL</li>
        <li>To improve website performance and analyze usage trends</li>
        <li>To comply with legal obligations and protect our services</li>
      </ul>

      <h2>3. Cookies and Tracking Technologies</h2>
      <p>
        We use cookies and similar tracking technologies to understand user behavior and improve your experience. You can
        manage your cookie preferences through your browser settings or via the cookie banner (if available).
      </p>

      <h2>4. Your Data Protection Rights (GDPR/UK GDPR)</h2>
      <p>
        Depending on your location, you may have the right to access, correct, delete, or restrict your personal data, as
        well as object to certain processing. To exercise these rights, contact{' '}
        <a href="mailto:privacy@healmusicapp.com">privacy@healmusicapp.com</a>.
      </p>

      <h2>5. Data Security</h2>
      <p>
        We take reasonable measures to protect your personal information. However, no system is completely secure, and we
        cannot guarantee the absolute security of your data.
      </p>

      <h2>6. Changes to This Policy</h2>
      <p>
        We may update this policy from time to time. If we make significant changes, we will notify you via email or a
        notice on our site.
      </p>

      <h2>7. Contact Us</h2>
      <p>
        For questions or data requests, contact us at{' '}
        <a href="mailto:privacy@healmusicapp.com">privacy@healmusicapp.com</a>.
      </p>
    </div>
  </div>
);

export default Privacy;
